<template>
  <div>

    <div v-if="loadingTable" class="d-flex justify-content-center w-100" style="margin-top: 30px">
      <Loading />
    </div>

    <div class="w-100" v-else-if="!loadingTable">
      <!-- Contenido de la tabla -->
      <table
        class="table table-bordered table-hover text-center stripe display compact hover mt-4" :id="dt_id" v-if="data_tabla.length">
        <!-- Headers -->
        <thead>
        <tr>
          <th style="width: 30px !important; font-size: 12.5px">
            #
          </th>
          <th
            style="font-size: 13px !important; max-width: 60px !important"
          >
            Semana
          </th>

          <th
            style="font-size: 13px !important; max-width: 140px !important"
          >
            Naviera
          </th>
          <th
            style="font-size: 13px !important; max-width: 180px !important"
          >
            Servicio
          </th>
          <th
            style="font-size: 13px !important; max-width: 170px !important"
          >
            Nave
          </th>
          <th
            style="font-size: 13px !important; max-width: 84px !important"
          >
            Cant Cont
          </th>
          <th
            style="font-size: 13px !important; max-width: 105px !important"
          >
            Stacking FROM
          </th>
          <th
            style="font-size: 13px !important; max-width: 90px !important"
          >
            Stacking TO
          </th>
          <th
            style="font-size: 13px !important; max-width: 80px !important"
          >
            POL ETA
          </th>
          <th
            style="
                font-size: 13px !important;
                width: 85px !important;
                max-width: 85px !important;
              "
          >
            POD ETA
          </th>
          <th
            style="font-size: 13px !important; max-width: 30px !important"
          >
            TT
          </th>

          <th
            style="font-size: 13px !important; max-width: 165px !important"
          >
            POL
          </th>

          <th
            style="font-size: 13px !important; max-width: 165px !important"
          >
            POD
          </th>

          <th
            style="font-size: 13px !important; max-width: 170px !important"
          >
            Contratos
          </th>
          <th
            style="font-size: 13px !important; max-width: 80px !important"
          >
            Seleccionar
          </th>
        </tr>
        </thead>
        <!-- Body -->
        <tbody>
        <!-- Recorre el total de objectos dentro del array -->
        <tr v-for="(object, index_object) in data_tabla" :key="index_object">

          <th style="width: 30px !important; font-size: 12.5px">{{ index_object + 1}}</th>

          <td v-for="(item, index_item) in object.data" :key="index_item">

            <!-- Textbox Cantidad -->
            <!-- <input type="text" v-if="index_item == 5" class="textbox_normal" @change="actualizarEstadoVariable(5,'cantidad',$event,index_object)" /> -->

            <!-- Select POL -->
            <template v-if="index_item === 10">
              <select style="width: 100% !important; height:32.5px; border-radius:5px;" v-model="data_tabla[index_object].data_complementaria.picked_charging_port"
                      @change="actualizarEstadoVariable(10, 'ports', $event, index_object); getDischargePorts(data_tabla[index_object], index_object);">
                <option selected hidden value="">-Seleccionar-</option>
                <option style="width: 50% !important; padding: 2px 0 !important"
                        v-for="(item, index) in object.data[10]" :key="index"
                        :value="item.id + '-' + item.name + '-' + item.charging_ports_id">
                  {{ item.name }}
                </option>
              </select>
            </template>

            <!-- Select POD -->
            <template v-else-if="index_item === 11">
              <select style="width: 100% !important; height:32.5px; border-radius:5px;" v-model="data_tabla[index_object].data_complementaria.picked_discharge_port"
                      @change="actualizarEstadoVariable(11, 'ports', $event, index_object)">
                <option selected hidden value="">-Seleccionar-</option>
                <option style="width: 50% !important; padding: 2px 0 !important"
                        v-for="(item, index) in destination_ports[object.data_complementaria.itinerary_id]"
                        :key="index" :value="item">
                  {{ item.name }}
                </option>
              </select>
            </template>

            <!-- Select Contratos -->
            <template v-else-if="index_item === 12">

              <!-- Contrato UCC -->
              <div v-if="data_tabla[index_object].data_complementaria.isContratoUCC" class="d-flex align-items-center">
                <input type="text" class="textbox_normal" style="min-width: 50px !important;"
                       @keyup="actualizarEstadoVariable(12,'textboxContrato',$event, index_object)" />
                <i class="fas fa-times text-danger ml-2" style="cursor:pointer"
                   @click="estadoContrato(index_object)"></i>
              </div>

              <!-- Contrato Fisico -->
              <select v-if="!data_tabla[index_object].data_complementaria.isContratoUCC"
                      style="width: 100% !important; height:32.5px; border-radius:5px;"
                      @change="actualizarEstadoVariable(12, 'tipoContrato', $event, index_object, false)">
                <option selected hidden>Seleccionar</option>
                <option value="Otro">Otro</option>
                <option style="padding: 2px 0 !important"
                        v-for="(item, index) in data_tabla[index_object].data_complementaria.contrato" :key="index"
                        :value="item.id">
                  {{ item.name }}
                </option>
              </select>

            </template>

            <!-- Checkbox -->
            <div v-else-if="index_item === 13" class="d-flex align-items-center justify-content-center"
                 style="height: 35px !important;">
              <input type="checkbox" style="height: 17px; width: 17px; cursor:pointer;" title="Seleccionar servicio"
                     @click="actualizarEstadoVariable(13, 'checkbox', $event, index_object)"
              />
            </div>

            <!-- Texto plano -->
            <template v-else>
              <div style="font-size:12px">{{ item }}</div>
            </template>
          </td>
        </tr>
        </tbody>
      </table>

      <!-- Botones -->
      <div class="d-flex justify-content-between mb-2 mt-4">
        <Button
          text="Cancelar"
          class="w-20"
          style="margin-bottom: 0px !important"
          color="#c12020"
          colorText="#fff"
          icon="fas fa-times"
          title="Cancelar"
          horizontal
          @click.native="cerrarModal"
        />

        <Button v-if="isSendData"
                text="Procesando"
                style="margin-bottom: 0px !important"
                color="#21831b"
                colorText="#fff"
                icon="far fa-paper-plane"
                title="Asignar Servicio"
                horizontal
                inactive
        />

        <Button v-else
                text="Asignar Servicio"
                style="margin-bottom: 0px !important"
                color="#21831b"
                colorText="#fff"
                icon="far fa-paper-plane"
                title="Asignar Servicio"
                horizontal
                @click.native="enviarData"
        />
      </div>

    </div>

    <NotFoundTable v-else text="No se registran servicios" class="mt-5" />
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapActions, mapState } from "vuex";

// Toast
import VueToastify from "vue-toastify";
// Importación de Jquery
import $ from "jquery";

// Constantes
import {
  changeItinerary,
  getBookingsConfirmadosCliente,
  getBookingsEmbarcados,
  getBookingsSolicitudesModificacion,
  getItineraryDischargePorts,
  obtenerContrato,
  obtenerServiciosBookingDeclarado
} from "@/constants/lineas";

import Button from "../../../../common/Button";
import Loading from "../../../../common/loading.vue";
import NotFoundTable from "../../../../common/NotFoundTable.vue";

Vue.use(VueToastify);

export default {
  props: ["dataBKN", "cantidadMin","redirect", "id", "changeService", "booking_itinerary_id"],
  computed: {
    ...mapState(["loading", "refrescarTable", "loadingTable", "puertos"]),
    ...mapState("lineas", [
        "visibleModalAceptarBookingDeclarado",
        'infoSolicitudModificacion'
      ])
  },

  data() {
    return {
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Ultimo",
          next: "Siguiente",
          previous: "Anterior"
        },
        buttons: {
          colvis: "Seleccionar columnas"
        }

      },
      pagination: true,
      max_per_page:  10,
      search: true,
      dt_id: 'cambiar-servicio-bkg-tbl',
      //
      data_tabla: [],
      destination_ports: [],
      accionesAux: [],
      dataModalSeleccionada: [],
      // Variables para obtener contrato
      data_aux_contrato: [],
      tipo_container: "",
      id_booking: '',
      isSendData : false,
      isContratoUCC : false
    };
  },

  components: {
    Button,
    Loading,
    NotFoundTable
  },

  methods: {
    // Acciones de Vuex
    ...mapActions([
      "ActionSetLoading", 
      "ActionSetLoadingTable",
      'ActionSetVisibleModalEditarBookingConfirmado', 
      "ActionSetVisibleModalEditarSolicitudModificacion",
      "ActionSetVisibleModalEditarBookingEmbarcado"
    ]),
    ...mapActions("lineas", [
      "actionSetVisibleModalAceptarBookingDeclarado",
      "actionSetDataDatatableBookingsDeclarados",
      "actionSetPolAux",
      "actionSetNaveAux",
      "actionSetViajeAux",
      "ActionSetContadorMenuBookings",
      "actionSetDataDatatableBookingsSolicitados",
      "actionSetDatatableBookingsConfirmados",
      "actionSetVisibleModalCambiarServicioConfirmadoBooking",
      "actionSetVisibleModalInformacionGeneral",
      "actionSetIdBookingItinerary",
      "actionSetDatatableBookingsSolicitudesModificacion",
      "actionSetDataDatatableBookingsEmbarcados",
    ]),

    dataTableSetup() {

      $("#" + this.dt_id)
        .DataTable()
        .destroy();

      $("#" + this.dt_id)
        .DataTable({
          paging: this.pagination,
          pageLength: this.max_per_page,
          searching: this.search,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          language: this.lang
        })
        .buttons()
        .container()
        .appendTo("#" + this.dt_id + "_wrapper .col-md-6:eq(0)");
    },

    async cargarServicios() {

      this.dataModalSeleccionada = [];

      this.data_tabla = [];

      this.ActionSetLoadingTable(true);

      let sql = await obtenerServiciosBookingDeclarado(this.id_booking, false);

      if (sql) {

        this.data_aux_contrato = sql.data[0].data_complementaria;

        this.actionSetPolAux(sql.data[0].data.pol);
        this.actionSetNaveAux(sql.data[0].data.nave);
        this.actionSetViajeAux(sql.data[0].data.viaje);

        let data_servicios = sql.serviciosParaBooking;

        if (Object.keys(data_servicios).length > 0) {

          //$("#" + this.dt_id + "").DataTable().destroy();

          data_servicios.map( item => {

            this.data_tabla.push({
              data: [
                item.data.semana,
                item.data.naviera,
                item.data.servicio,
                item.data.nave,
                item.data.disp,
                item.data.stacking_from,
                item.data.stacking_to,
                item.data.pol_etd,
                item.data.pod_eta,
                item.data.tt,
                item.data_complementaria.selector_pol,
                [],
                [],
                false
              ],
              data_complementaria: {
                pol_value: "",
                bookingOffice: "",
                bookingOffice_value: "",
                // contrato: item.data_complementaria.contratosPorServicio,
                contrato: [],
                contratoUCC : "",
                contratoFisico: "",
                contieneContrato: true,
                itinerary_id: item.chargin_ports[0].itinerary_id,
                charging_ports_id: item.data_complementaria.charging_ports_id,
                discharge_ports_id: item.data_complementaria.discharge_ports_id,
                container_type: item.data_complementaria.container_type,
                transhipment_port_id: item.data_complementaria.transhipment_port_id,
                id_naviera: item.data.naviera_id,
                picked_charging_port: "",
                picked_discharge_port: "",
                checked : false,
                isContratoUCC :false
              },
            });

          });

          this.dataTableSetup();

        } else {

          this.$vToastify.warning(
            "El servicio seleccionado no cuenta con registros",
            "Atención!"
          );
          this.ActionSetLoadingTable(false);

        }

      } else {

        this.$vToastify.warning(
          "El servicio seleccionado no cuenta con registros",
          "Atención!"
        );
        this.ActionSetLoadingTable(false);

      }

    },

    async actualizarEstadoVariable(index, tipo, valorInput, index_object) {
      // Variables locales
      let data_final = [], dataObtenerContrato = {}, sql = [], charging_port = [], is_transhipment = false;

      let polPortID, chargingPortName, chargingPortId, podPortID, id_select = "";

      switch (tipo) {

        case "cantidad":

          // Asignación de nuevo valor
          this.data_tabla[index_object].data[index] = valorInput.target.value;

          break;

        case "ports":

          // Realiza split a nombre compuesto (id + name + port_id) asignado en la creación del select POL
          charging_port = this.data_tabla[index_object].data_complementaria.picked_charging_port;

          polPortID = charging_port.split("-")[0];
          chargingPortName = charging_port.split("-")[1];
          chargingPortId = charging_port.split("-")[2];

          //Puerto de descarga sea transbordo o no
          podPortID =  this.data_tabla[index_object].data_complementaria.picked_discharge_port.port_id ?? null;

          //se valida que esten ambos puertos para poder consultar los contratos
          if ((polPortID !== "" && polPortID !== undefined && polPortID !== null) &&
            (podPortID !== "" && podPortID !== undefined && podPortID !== null)) {

            //Pol
            // Se asigna valor predetermninado en select BookingOffice
            this.data_tabla[index_object].data_complementaria.bookingOffice = chargingPortName;
            this.data_tabla[index_object].data_complementaria.bookingOffice_value = polPortID;
            this.data_tabla[index_object].data_complementaria.pol_value = polPortID;
            this.data_tabla[index_object].data_complementaria.chargin_port_selected = chargingPortId;

            //Pod
            if (this.data_tabla[index_object].data_complementaria.picked_discharge_port.transhipment) {

              this.data_tabla[index_object].data_complementaria.transhipment_ports_id = this.data_tabla[index_object].data_complementaria.picked_discharge_port.id;

              is_transhipment = true;

            } else {

              this.data_tabla[index_object].data_complementaria.discharge_ports_id = this.data_tabla[index_object].data_complementaria.picked_discharge_port.id;

            }

            // Data necesaria para realizar consulta para obtener el contrato
            dataObtenerContrato = {
              from_date: this.data_aux_contrato.pol_etd,
              pol: parseInt(polPortID),
              pod: parseInt(podPortID),
              naviera_id: this.data_tabla[index_object].data_complementaria.id_naviera,
              products_category_id: this.data_aux_contrato.products_category_id,
              container_id: this.data_aux_contrato.container_id,
              atmosphere_id: this.data_aux_contrato.atmosphere_id,
              client_id: this.data_aux_contrato.id_client,
              charging_ports_id: this.data_tabla[index_object].data_complementaria.charging_ports_id,
              discharge_ports_id: this.data_tabla[index_object].data_complementaria.discharge_ports_id ?? null,
              transhipment_port_id: this.data_tabla[index_object].data_complementaria.transhipment_ports_id ?? null,
              is_transhipment: is_transhipment
            };

            sql = await obtenerContrato(dataObtenerContrato);

            if (sql) {

              this.data_tabla[index_object].data_complementaria.contrato = [];

              sql.map(item => {

                this.data_tabla[index_object].data_complementaria.contrato.push({
                  id: item.tariff_client_id,
                  name: item.contrato
                });
              });

              // Se habilita select que lista contratos
              this.data_tabla[index_object].data_complementaria.contieneContrato = true;

            } else {
              // Se habilita texbox cuando no contiene contratos asociados
              this.data_tabla[index_object].data_complementaria.contieneContrato = false;
            }

            break;

          }

          break;


        case "bookingOffice":

          // Realiza split a nombre compuesto (id+name) asignado en la creación del select POL
          id_select = valorInput.target.value.split("-")[0];

          this.data_tabla[index_object].data_complementaria.bookingOffice_value = id_select;

          break;

        case "tipoContrato" :

          if (valorInput.target.value === "Otro") {

            this.data_tabla[index_object].data_complementaria.isContratoUCC = true;

            this.data_tabla[index_object].data_complementaria.contratoFisico = "";

          }

          if (valorInput.target.value !== "Otro") {

            this.data_tabla[index_object].data_complementaria.contratoFisico = valorInput.target.value;

            this.data_tabla[index_object].data_complementaria.contratoUCC = "";

          }

          break;

        case "textboxContrato":

          this.data_tabla[index_object].data_complementaria.contratoUCC = valorInput.target.value;

          break;

        case "checkbox":

          if (valorInput.target.checked) {

            this.data_tabla[index_object].data_complementaria.checked = true;

            this.dataModalSeleccionada.push({
              data: this.data_tabla[index_object],
              index: index_object
            });

          } else {

            this.data_tabla[index_object].data_complementaria.checked = false;

            this.dataModalSeleccionada.map((item) => {
              if (index_object !== item.index) {
                data_final.push(item);
              }
            });

            this.dataModalSeleccionada = data_final;

          }

          break;

        default:

          break;
      }

    },

    async enviarData() {

      let data_a_enviar = [];

      let errors = 0;

      let cantidadTotalASolicitar = 0 ;

      if( this.dataModalSeleccionada.length > 1 ){

        return this.$vToastify.error("Solo debe seleccionar un Servicio", "Error");
        
      }

      this.dataModalSeleccionada.forEach( ds => cantidadTotalASolicitar += +ds.data.data[5] );

      if ( this.dataModalSeleccionada.length === 0) {

        return this.$vToastify.error("Debe seleccionar al menos un registro", "Seleccione un servicio");

      }

      this.dataModalSeleccionada.map( item => {

        let { data, data_complementaria } = item.data;

        //pol
        let polError = this.validateRequired(data_complementaria.picked_charging_port, "POL");

        if (polError !== true) {
          errors++;
          return this.$vToastify.error(polError, "Error: POL");
        }

        //pod
        let podError = this.validateRequired(data_complementaria.picked_discharge_port, "POD");

        if (podError !== true) {
          errors++;
          return this.$vToastify.error(podError, "Error: POD");
        }

        //contratos
        if (data_complementaria.isContratoUCC) {

          let contractsError = this.validateRequired(data_complementaria.contratoUCC, "Contratos");

          if (contractsError !== true) {
            errors++;
            return this.$vToastify.error(contractsError, "Error: Contratos");
          }

        } else {

          let contractsError = this.validateRequired(data_complementaria.contratoFisico, "Contratos");

          if (contractsError !== true) {
            errors++;
            return this.$vToastify.error(contractsError, "Error: Contratos");
          }

        }

        let contractsError = this.validateRequired(data_complementaria.contrato, "Contratos");

        if (contractsError !== true) {
          errors++;
          return this.$vToastify.error(contractsError, "Error: Contratos");
        }

        data_a_enviar.push( !this.changeService ? {
          itinerary_id          : data_complementaria.itinerary_id,
          week                  : this.dataBKN.data[1],
          booking_id            : this.id_booking,
          pol_eta               : data[8],
          pod_eta               : data[9],
          transhipment_ports_id : this.dataBKN.data_complementaria.transhipment_ports_id,
          transhipment_port_id  : data_complementaria.transhipment_port_id,
          cant                  : data[5],
          booking_office_id     : parseInt(data_complementaria.bookingOffice_value),
          contratoFisico        : data_complementaria.contratoFisico,
          contratoUCC           : data_complementaria.contratoUCC,
          tariff_client_id      : "",
          charging_ports_id     : data_complementaria.charging_ports_id,
          discharge_ports_id    : data_complementaria.discharge_ports_id,
          container_type        : data_complementaria.container_type,
          id_naviera            : data_complementaria.id_naviera,
          id_booking            : this.id_booking,
          checked               : data_complementaria.checked

        } : {

          itinerary_id          : data_complementaria.itinerary_id,
          week                  : data[0],
          booking_id            : this.id_booking,
          pol_eta               : data[8],
          pod_eta               : data[9],
          transhipment_ports_id : data_complementaria.transhipment_port_id,
          transhipment_port_id  : data_complementaria.transhipment_port_id,
          cant                  : data[5],
          booking_office_id     : parseInt(data_complementaria.bookingOffice_value),
          contratoFisico        : data_complementaria.contratoFisico,
          contratoUCC           : data_complementaria.contratoUCC,
          tariff_client_id      : "",
          charging_ports_id     : data_complementaria.charging_ports_id,
          discharge_ports_id    : data_complementaria.discharge_ports_id,
          container_type        : data_complementaria.container_type,
          id_naviera            : data_complementaria.id_naviera,
          id_booking            : this.id_booking,
          checked               : data_complementaria.checked
        });
      });

      let contract, tariff_client_id = null;

      if (this.dataModalSeleccionada[0].data.data_complementaria.isContratoUCC) {

        contract = this.dataModalSeleccionada[0].data.data_complementaria.contratoUCC;

        tariff_client_id = null;

      } else {

        tariff_client_id = this.dataModalSeleccionada[0].data.data_complementaria.contratoFisico;

        contract = null;

      }

      if (errors === 0) {

        this.isSendData = true;
        try {

          this.$vToastify.loader("Procesando solicitud de Booking...");

          const form = {
            booking_itinerary_id : this.booking_itinerary_id,
            itinerary_id : this.dataModalSeleccionada[0].data.data_complementaria.itinerary_id ?? null,
            charging_ports_id:  this.dataModalSeleccionada[0].data.data_complementaria.chargin_port_selected ?? null,
            discharge_ports_id:  this.dataModalSeleccionada[0].data.data_complementaria.discharge_ports_id ?? null,
            contract:  contract,
            tariff_client_id: parseInt(tariff_client_id) ?? null,
            transhipment_port_id:  this.dataModalSeleccionada[0].data.data_complementaria.transhipment_port_id ?? null,
            pol_eta : this.dataModalSeleccionada[0].data.data[7],
            pod_eta : this.dataModalSeleccionada[0].data.data[8],
            modification_request : this.infoSolicitudModificacion.bookingItineraryId ? this.infoSolicitudModificacion : null ,
          } ;

          await changeItinerary( form );

          this.dataModalSeleccionada = [] ;
          this.isSendData = false;

          const { name } = this.$route ;

          switch ( name ) {

            case 'solicitudesModificacion': {

              const { data_table } = await getBookingsSolicitudesModificacion();

              this.actionSetDatatableBookingsSolicitudesModificacion( data_table ) ;
              this.actionSetVisibleModalInformacionGeneral(false) ;
              this.ActionSetVisibleModalEditarSolicitudModificacion(false) ;
            }
            break;

            case 'bookingsConfirmados': {

              const { data_table } = await getBookingsConfirmadosCliente();

              this.actionSetDatatableBookingsConfirmados( data_table ) ;
              this.actionSetVisibleModalCambiarServicioConfirmadoBooking(false);
              this.ActionSetVisibleModalEditarBookingConfirmado(false) ;
            }
            break;

            case 'bookingsEmbarcados': {

              const { data_table } = await getBookingsEmbarcados();
              this.actionSetDataDatatableBookingsEmbarcados( data_table ) ;
              this.ActionSetVisibleModalEditarBookingEmbarcado(false) ;
              this.actionSetVisibleModalCambiarServicioConfirmadoBooking(false) ;
            }
            break;
          }

          this.actionSetIdBookingItinerary( null ) ;

          this.$vToastify.stopLoader();
          this.$vToastify.success("Cambio de servicio realizado éxito", "Realizado");
          await this.cargarServicios() ;



          if( this.redirect !== undefined ) await this.redirect() ;

        } catch (error) {
          this.isSendData = false;
          this.$vToastify.stopLoader();
          this.$vToastify.error( "Hubo un problema al cambiar servicio. Por favor, recargue la página y vuelva internar (0)." , "Error");
        }

      }
    },

    async getDischargePorts(data, index) {

      const itinerary_id = data.data_complementaria.itinerary_id;

      this.destination_ports[itinerary_id] = [];

      this.data_tabla[index].data_complementaria.picked_discharge_port = "";

      const request = {
        itinerary_id: itinerary_id,
        discharge_port_id: data.data_complementaria.discharge_ports_id ?? null,
        transhipment_port_id: data.data_complementaria.transhipment_port_id ?? null
      };

      const ports = await getItineraryDischargePorts(request);

      this.$set(this.destination_ports, itinerary_id, ports);

    },

    cerrarModal() {
      this.actionSetVisibleModalCambiarServicioConfirmadoBooking(false);
    },

    validateRequired(model = null, name) {
      if (model !== null) {
        if (model === "" || model === undefined || model === "-") {
          return "El espacio '" + name + "' no debe quedar vacío";
        }
        return true;
      }
    },

    validateNumeric(model = null, name) {
      if (model !== null) {
        let required = this.validateRequired(model, name);
        if (required !== true) {
          return required;
        }
        if (isNaN(model)) {
          return "El espacio '" + name + "' debe ser numérico";
        }
        if (model <= 0) {
          return "El espacio '" + name + "' debe ser mayor que 0";
        }
        return true;
      }
    },

    estadoContrato(index){
      this.data_tabla[index].data_complementaria.isContratoUCC = false;
      this.data_tabla[index].data_complementaria.contratoUCC    = "";
    }
  },

  watch: {
    acciones: function(_new) {
      if (_new) {

        this.accionesAux = _new;

      }
    },

    dataBKN: async function(_new) {
      if (_new) {

        this.id_booking = _new.data_complementaria.id_booking;

        this.ActionSetLoadingTable(true);

        await this.cargarServicios();

        this.dataTableSetup();

      }
    },

    id: async function(_new) {
      if (_new) {

        this.id_booking = _new;

        this.ActionSetLoadingTable(true);

        await this.cargarServicios();

        this.dataTableSetup();
      }
    }
  }
};
</script>

<!-- Stilos css -->
<style>

.textbox_normal {
    width: 100% !important;
}
</style>
